import React from 'react';

import { Maybe } from 'graphql/jsutils/Maybe';
import { Event, WithContext } from 'schema-dts';

import { getStringValue } from '@r-client/shared/util/core';
import { JsonLinkedData } from '@r-client/shared/util/seo';

type TAddress = {
  city?: Maybe<string>;
  state?: Maybe<string>;
  postalCode?: Maybe<string>;
  street1?: Maybe<string>;
};

interface ISEOStructuredDataProps {
  dataTestId?: string;
  data: {
    coverPhotoUrl?: Maybe<string>;
    title: string;
    beginAt: string;
    endAt?: Maybe<string>;
    body?: Maybe<string>;
    url?: Maybe<string>;
    address?: Maybe<TAddress>;
  };
}

const getIsoString = (dateStr: string) => new Date(dateStr).toISOString();

export const SEOStructuredData: React.FC<
  React.PropsWithChildren<ISEOStructuredDataProps>
> = ({ data, dataTestId }) => {
  const { address } = data;
  const schema: WithContext<Event> = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    eventStatus: 'EventScheduled',
    ...(data.coverPhotoUrl ? { image: data.coverPhotoUrl } : {}),
    name: data.title,
    startDate: getIsoString(data.beginAt),
    endDate: data.endAt ? getIsoString(data.endAt) : '',
    description: getStringValue(data.body),
    url: data.url ?? '',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: getStringValue(address?.city),
        addressRegion: getStringValue(address?.state),
        postalCode: getStringValue(address?.postalCode),
        streetAddress: getStringValue(address?.street1),
      },
    },
  };
  return <JsonLinkedData dataTestId={dataTestId} schema={schema} />;
};
